import { CustomNode } from '../../components/custom-nodes/types';

export * from './get-nodes-bounds';
export * from './check-paste';
export * from './get-id';
export * from './recalculate-node-x-positions';
export * from './recalculate-node-y-positions';
export * from './compose-hocs';
export * from './update-node';
export * from './delete-node';
export * from './delete-if-statement';
export * from './get-nearest-node-by-type';
export * from './get-nodes-between';
export * from './get-valid-if-statement-nodes';
export * from './get-valid-goto-statement-nodes';
export * from './get-preceded-nodes';
export * from './serializer/hydrate-node-attrs';
export * from './serializer/hydrate-node-edges';

export const getPlaceholderNodes = (nodes: CustomNode[]) => {
  return nodes.filter((node) => node.id.startsWith('placeholder_'));
}

export const getNodesWithoutPlaceholders = (nodes: CustomNode[]) => {
  return nodes.filter((node: CustomNode) => !node.id.startsWith('placeholder_'));
}
